import Config from '../config/environment'
import {
  UserGetResponse,
  UserPatchResponse,
  UserUpdateFields,
} from '../types/user'

const { REST_API_URL } = Config

export const getUser = async function () {
  const authResponse = await fetch(`${REST_API_URL}/users/me`, {
    method: 'GET',
    credentials: 'include',
  })
  const data = (await authResponse.json()) as UserGetResponse
  if ('error' in data) {
    throw new Error(data.error.message)
  }
  return data
}

export const updateUser = async function (payload: UserUpdateFields) {
  const updateUserResponse = await fetch(`${REST_API_URL}/users/me`, {
    method: 'PATCH',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })
  if (updateUserResponse.status !== 204) {
    const data = (await updateUserResponse.json()) as UserPatchResponse
    if ('error' in data) {
      throw new Error(data.error.message)
    }
  }
  return {
    userUpdated: true,
  }
}
